import React, { useEffect } from 'react';
import { ContentCont } from './OpportunitiesContent.styles';
import ProjectItem from './ProjectItem/ProjectItem';
import { useContextSelector } from 'use-context-selector';
import { OpportunitiesContext } from 'pages/Opportunities/context/OpportunitiesContext';
import OpportunitiesLoader from './OpportunitiesLoader';
import ProjectLoaders from './Loaders/ProjectLoaders';

const AppliedContent: React.FC = () => {
  const opportunities = useContextSelector(OpportunitiesContext, (state) => state.appliedDataState);
  const opportunitiesFetching = useContextSelector(OpportunitiesContext, (state) => state.appliedFetching);
  const opportunitiesRefetching = useContextSelector(OpportunitiesContext, (state) => state.appliedRefetching);
  const fetchMoreOpportunities = useContextSelector(OpportunitiesContext, (state) => state.fetchMoreApplied);

  const SCROLL_ALLOWANCE = 100;
  // useEffect(() => {
  //   console.log('AppliedContent Rendered');
  // });

  const handleOnscroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollHeight, scrollTop, clientHeight } = e.currentTarget;

    const currentScroll = scrollHeight - scrollTop - SCROLL_ALLOWANCE;

    if (currentScroll < clientHeight) {
      fetchMoreOpportunities();
    }
  };

  if (opportunitiesFetching) return <OpportunitiesLoader />;

  return (
    <ContentCont onScroll={handleOnscroll} jobs={0}>
      {opportunities.map((p) => (
        <ProjectItem key={p.id} project={p} projectType="submitted" />
      ))}
      {opportunitiesRefetching && <ProjectLoaders />}
    </ContentCont>
  );
};

export default React.memo(AppliedContent);
